export default __webpack_public_path__ + "static/2_Screenshot-867e2fe4d565b87e05fde69b0905f386.png";